import React from 'react';
import {render} from 'react-dom';
import ReactModal from "react-modal";
import styles from './loading.css';
import LoaderComponent from "../../../components/loader/loader";

const node = window.document.createElement('div');
node.id = `__loading`;
window.document.body.appendChild(node);
/*
const Loading = ({message, overlayClassName}) => (
    <ReactModal key="__loading" isOpen={message !== undefined} className={styles.modal} overlayClassName={overlayClassName || styles.overlay}>
        {message || window.L('teach.loading')}
    </ReactModal>
);
 */
const Loading = LoaderComponent;

const showLoading = (message) => {
    render(<Loading message={message}/> , node)
}

const hideLoading = () => {
    render(null, node);
}

export {
    Loading as default,
    showLoading,
    hideLoading
};
